var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.validate.apply(null, arguments)}}},[_c('div',{staticClass:"text-center"},[_c('v-btn',{attrs:{"loading":_vm.loading,"color":"primary","large":"","type":"submit","text":"","rounded":""}},[_vm._v(_vm._s(_vm.$t("auth.sign_in")))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }